import { Component, OnInit, Input, ViewEncapsulation, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { TaskbarService } from '../taskbar.service';

@Component({
  selector: 'ngxui-footer-taskpane',
  templateUrl: './footer-taskpane.component.html',
  styleUrls: ['./footer-taskpane.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterTaskpaneComponent implements OnInit, OnDestroy {
    unsubscribe = new Subject();
    @Input() Width: string; /*em,px,% ens*/
    @Input() Height: string; /*Same as above*/
    @Input() HideRecentActivities: boolean = false;
    @Input() HideTileMenu: boolean = false;
    @Input() HideUserMenu: boolean = false;

    collapse:string = "closed";

    constructor(
        public taskbarService: TaskbarService
    ) {

        this.taskbarService.TaskbarPaneSubject
        .pipe(
            takeUntil(this.unsubscribe)
        )
        .subscribe( (value: boolean) => {
            this.taskbarService.ShowPane = value;
            this.collapse = this.collapse === 'open' ? 'closed' : 'open';
        } );
    }

    ngOnInit() {
    }

    ngOnDestroy(){
        this.unsubscribe.next();
        this.unsubscribe.complete();
        this.unsubscribe.unsubscribe();
    }

    closeTaskPane(event){
        try {
            event.preventDefault();
        } catch(ex) {

        }

        this.taskbarService.ShowPane = false;
    }

}
